import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MainNavComponent } from './main-nav/main-nav.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatGridListModule } from '@angular/material/grid-list';
import { AchievementsComponent } from './achievements/achievements.component';
import { AchievementsService } from './achievements/achievements.service';
import { CardModule } from 'primeng/card';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactFormService } from './contact-form/contact-form.service';
import { DataProtectionNoticeComponent } from './data-protection-notice/data-protection-notice.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { environment } from '../environments/environment';
import { ImprintComponent } from './imprint/imprint.component';
import { MessageSentSuccessfullyComponent } from './message-sent-successfully/message-sent-successfully.component';

@NgModule({
  declarations: [
    AppComponent,
    MainNavComponent,
    AchievementsComponent,
    ContactFormComponent,
    DataProtectionNoticeComponent,
    ImprintComponent,
    MessageSentSuccessfullyComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatGridListModule,
    CardModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule
  ],
  providers: [AchievementsService, ContactFormService],
  bootstrap: [AppComponent]
})
export class AppModule { }
